<template>
    <div class="coupon-container">
        <head-bar title="优惠券" :fixed="true"></head-bar>
        <div class="tabs-container">
            <van-tabs v-model="activeName" @change="tabsChange" color="#4BC227">
                <van-tab title="可使用" name="100"></van-tab>
                <van-tab title="已使用" name="200"></van-tab>
                <van-tab title="已过期" name="300"></van-tab>
            </van-tabs>
        </div>
        <div class="coupon-list-box">
            <scroll :data-list="couponList" :finished="finished" @load="onLoad">
                <div class="conpon-list-warp">
                    <ul class="coupon-list" v-show="couponList.length != 0">
                        <counpon-item
                            v-for="(item, index) in couponList"
                            :key="index"
                            :coupon-info="item"
                        ></counpon-item>
                    </ul>
                    <div slot="icon">
                        <empty-data
                            v-show="couponList.length == 0"
                            iconText="暂无可用优惠券"
                            :iconSrc="emptyIcon"
                            iconSize="slim"
                            :paddingTop="6"
                        ></empty-data>
                    </div>
                </div>
            </scroll>
        </div>
    </div>
</template>
<script>
import EmptyData from "@/components/EmptyData";
import HeadBar from "@/components/HeadBar.vue";
import Scroll from "@/components/Scroll";
import CounponItem from "./children/CounponItem";
import Vue from "vue";
import { Tab, Tabs, List, Toast } from "vant";
Vue.use(Tab)
    .use(Tabs)
    .use(List)
    .use(Toast);
export default {
    name: "Coupon",
    components: {
        HeadBar,
        CounponItem,
        Scroll,
        EmptyData,
    },
    data() {
        return {
            //空数据icon
            emptyIcon: require("@/public/images/user/coupon/coupon-empty-icon.png"),
            activeName: "",
            loading: false, //是否加载中
            finished: false, //是否加载完毕
            page: 1,
            couponList: [],
            isUse: "", //是否使用
            isPast: "", //是否过期
            dataCount: 9999, //数据总条数
        };
    },
    beforeMount() {
        this.getCouponList();
    },
    mounted() {},
    methods: {
        /**
         * @description 获取优惠券
         */
        getCouponList() {
            let _this = this;
            let { page } = this.$data;
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            this.$axios
                .post(_this.$api.userApi.getConponList, {
                    context: {
                        useFlag: _this.isUse,
                        invalidFlag: _this.isPast,
                    },
                    page: {
                        currPage: page,
                        pageSize: _this.$config.PAGE_ITEMS,
                    },
                })
                .then((response) => {
                    let couponList = response.data.list || [];
                    let total = response.data.total || 0;
                    _this.couponList = _this.couponList.concat(couponList);
                    _this.page += 1;
                    _this.dataCount = total;
                    _this.$toast.clear();
                })
                .catch(() => {
                    _this.$toast.clear();
                });
        },
        /**
         * @description 加载数据
         */
        onLoad() {
            this.getCouponList();
            if (this.couponList.length >= this.dataCount) {
                this.finished = true;
            }
        },
        /**
         * @description 切换卡变更
         */
        tabsChange(tabInfo) {
            let _this = this;
            let strategyMap = {
                "100": () => {
                    _this.isUse = "";
                    _this.isPast = "";
                },
                "200": () => {
                    _this.isUse = true;
                    _this.isPast = "";
                },
                "300": () => {
                    _this.isUse = "";
                    _this.isPast = true;
                },
            };
            _this.finished = false;
            _this.page = 1;
            _this.couponList = [];
            strategyMap[`${tabInfo}`]();
            _this.onLoad();
        },
    },
};
</script>
<style lang="less" scoped>
.tabs-container {
    position: fixed;
    z-index: 1;
    top: 90px;
    width: 750px;
    left: 50%;
    margin-left: -375px;
}
.coupon-list-box {
    position: fixed;
    z-index: 1;
    top: 180px;
    bottom: 0;
    width: 750px;
    left: 50%;
    margin-left: -375px;
    background-color: #f6f6f6;
    .conpon-list-warp {
        width: 750px;
    }
}
.coupon-container {
    width: 750px;
}
.coupon-list {
    margin: 0 auto;
    width: 710px;
}
</style>
